import { Container } from '@cgs/wge';
import { SlotGameConfigManager } from './slot-game-config-manager';

export class SlotBonusGameConfigManager extends SlotGameConfigManager {
  private readonly configs: Map<string, any> = new Map();

  constructor(
    container: Container,
    private readonly bonusGames: string[]
  ) {
    super(container);
  }

  public async loadConfig(): Promise<Map<any, any> | null> {
    const gameConfig = await super.loadConfig();
    await this.loadBonusConfigs();

    return gameConfig;
  }

  private async loadBonusConfigs(): Promise<Map<string, any> | null> {
    const bonusConfigUrl = this.slotGameSettings.getBonusConfigUrl();

    if (!bonusConfigUrl) {
      throw new Error('Bonus config url is not set');
    }

    const loadPromises = this.bonusGames.map(async (bonusGame) => {
      const config = await this.loadBonusConfig(bonusGame, bonusConfigUrl);
      this.configs.set(bonusGame, config);
      return [bonusGame, config] as [string, any];
    });

    try {
      await Promise.all(loadPromises);
    } catch {
      return null;
    }

    return this.configs;
  }

  public getConfig(bonusGame: string): Promise<any> {
    return this.configs.get(bonusGame) || Promise.resolve(null);
  }

  private async loadBonusConfig(
    bonusGame: string,
    bonusConfigUrl: string
  ): Promise<Map<any, any> | null> {
    try {
      const response = await fetch(this.getUrl(bonusGame, bonusConfigUrl));

      return response.ok ? response.json() : null;
    } catch {
      return null;
    }
  }

  private getUrl(bonusGame: string, bonusConfigUrl: string): string {
    return `./${bonusConfigUrl}/game_${bonusGame}.json`;
  }
}
